module.exports = __webpack_public_path__ + "img/pvc_staande_plakplint.9ee0fbae.jpg";